"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ɵ0 = exports.appRoutes = void 0;
const orderlookup_component_1 = require("./views/orderlookup/orderlookup.component");
const orderdetails_component_1 = require("./views/orderdetails/orderdetails.component");
const preorderdetails_component_1 = require("./views/preorderdetails/preorderdetails.component");
const orderaccessauth_service_1 = require("./services/orderaccessauth.service");
const edit_preorder_device_component_1 = require("./views/preorder-mma/edit-preorder-device/edit-preorder-device.component");
const ɵ0 = () => Promise.resolve().then(() => require("./routes/preorder-mma/preorder-mma.module.ngfactory")).then((preorder) => preorder.CSPreorderMMAModuleNgFactory);
exports.ɵ0 = ɵ0;
exports.appRoutes = [
    { path: '', component: orderlookup_component_1.CSLookupOrderComponent, canActivate: [orderaccessauth_service_1.OrderAccessAuthGuardService] },
    { path: 'details', component: orderdetails_component_1.CSOrderDetailsComponent, canActivate: [orderaccessauth_service_1.OrderAccessAuthGuardService] },
    { path: 'preorder-details', component: preorderdetails_component_1.CSPreOrderDetailsComponent, canActivate: [orderaccessauth_service_1.OrderAccessAuthGuardService] },
    { path: 'preorder/:preorderId/:subId/:curDeviceId', component: edit_preorder_device_component_1.CSMMAEditPreOrderDeviceComponent },
    {
        path: 'preorder',
        loadChildren: ɵ0
    },
    { path: '**', component: orderlookup_component_1.CSLookupOrderComponent, canActivate: [orderaccessauth_service_1.OrderAccessAuthGuardService] }
];
//# sourceMappingURL=app.route.js.map